/**
 * @generated SignedSource<<aefff22a40a309438aaecf5344a98b40>>
 * @relayHash d0ebf4a4ad44eb19a0a1f0a93250c888
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f36b0eef5d8fa7c63c71625e945d131f6839456bf7a2512aa5cd06fbe2a3e87

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentUnifiedQuery$variables = {
  agentSessionsPropertyKey?: string | null;
  bylineContributorsLimit?: number | null;
  contentId: string;
  fetchAgentSessionsMarker?: boolean | null;
  includeAgentTrustReceiptData?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeReactions?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey?: string | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly agentSessionsMarker?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly body: {
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly contentProperties?: {
        readonly latest: {
          readonly generatedBy: string | null;
        } | null;
      } | null;
      readonly contentTitleWithByLine?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
      } | null;
      readonly history?: {
        readonly createdBy: {
          readonly displayName: string | null;
        } | null;
        readonly createdDate: string | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly macroRenderedOutput?: ReadonlyArray<{
        readonly key: string | null;
        readonly value: {
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth?: string | null;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageRestrictionsContext?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
      } | null;
      readonly pageRestrictionsContextAncestors?: {
        readonly ancestors: ReadonlyArray<{
          readonly hasRestrictions: boolean;
          readonly id: string | null;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly title: string | null;
        } | null> | null;
        readonly id: string | null;
      } | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly reactionsContent?: {
        readonly contentReactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly id: string | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version: {
        readonly confRev: string | null;
        readonly number: number | null;
        readonly when?: string | null;
      } | null;
      readonly viewPageLabels?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageStatusQueryRelaySpike_content" | "PresenterModePortal_content">;
    } | null> | null;
  } | null;
  readonly contentContributors?: {
    readonly " $fragmentSpreads": FragmentRefs<"ByLineContributors_contentContributors">;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentContainerTheme_space" | "ContentTitle_space">;
  } | null;
};
export type ContentUnifiedQuery = {
  response: ContentUnifiedQuery$data;
  variables: ContentUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "agentSessionsPropertyKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bylineContributorsLimit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAgentSessionsMarker"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v14 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v15 = [
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "count"
},
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "ScalarField",
  "name": "label"
},
v20 = {
  "kind": "ScalarField",
  "name": "name"
},
v21 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v22 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v17/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v18/*: any*/)
      ]
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v24 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v25 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v26 = {
  "kind": "ScalarField",
  "name": "title"
},
v27 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v26/*: any*/),
    (v25/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        }
      ]
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "type"
},
v29 = {
  "kind": "ScalarField",
  "name": "status"
},
v30 = {
  "kind": "ScalarField",
  "name": "number"
},
v31 = {
  "kind": "ScalarField",
  "name": "when"
},
v32 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confRev"
    },
    (v30/*: any*/),
    {
      "condition": "includeAgentTrustReceiptData",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v31/*: any*/)
      ]
    }
  ]
},
v33 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "coverPictureWidth"
            }
          ]
        }
      ]
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "name": "representation"
},
v35 = {
  "kind": "ScalarField",
  "name": "value"
},
v36 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v30/*: any*/)
  ]
},
v37 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v38 = [
  (v37/*: any*/)
],
v39 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v34/*: any*/),
        (v35/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v36/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v38/*: any*/)
            },
            (v37/*: any*/)
          ]
        }
      ]
    }
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "key"
},
v41 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v18/*: any*/),
      (v40/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/)
    ]
  }
],
v42 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v43 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v44 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "subType"
},
v46 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v40/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v47 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v48 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v49 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v50 = {
  "condition": "useNewContentTopper",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "pageTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v41/*: any*/),
      "storageKey": "properties(key:\"page-title-property-published\")"
    }
  ]
},
v51 = {
  "condition": "isSSR",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MapOfStringToFormattedBody",
      "kind": "LinkedField",
      "name": "macroRenderedOutput",
      "plural": true,
      "selections": [
        (v40/*: any*/),
        {
          "concreteType": "FormattedBody",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            (v35/*: any*/),
            (v34/*: any*/),
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": (v38/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v52 = {
  "condition": "fetchAgentSessionsMarker",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "agentSessionsMarker",
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "agentSessionsPropertyKey"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v41/*: any*/)
    }
  ]
},
v53 = [
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "bylineContributorsLimit"
  }
],
v54 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v55 = {
  "kind": "ScalarField",
  "name": "themeKey"
},
v56 = {
  "kind": "ScalarField",
  "name": "background"
},
v57 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v58 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v59 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v60 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v61 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v62 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v63 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v64 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v65 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v66 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    (v57/*: any*/),
    (v58/*: any*/),
    (v59/*: any*/),
    (v60/*: any*/),
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        (v57/*: any*/),
        (v58/*: any*/),
        (v59/*: any*/),
        (v60/*: any*/),
        (v61/*: any*/),
        (v62/*: any*/),
        (v63/*: any*/),
        (v64/*: any*/),
        (v65/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v67 = {
  "kind": "ScalarField",
  "name": "padding"
},
v68 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v69 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    (v57/*: any*/),
    (v58/*: any*/),
    (v59/*: any*/),
    (v60/*: any*/),
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/),
    (v67/*: any*/),
    (v68/*: any*/)
  ]
},
v70 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v71 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v72 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v73 = [
  (v72/*: any*/),
  (v28/*: any*/),
  (v48/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "accountId"
      }
    ],
    "type": "KnownUser"
  },
  {
    "concreteType": "Icon",
    "kind": "LinkedField",
    "name": "profilePicture",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "path"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PageStatusQueryRelaySpike_content"
              },
              {
                "kind": "FragmentSpread",
                "name": "PresenterModePortal_content"
              },
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "useNewContentTopper",
                              "variableName": "useNewContentTopper"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "ContentTitleWithByLine_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentTitleWithByLine"
                  }
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageLabelsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageLabels"
                  },
                  {
                    "args": (v16/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v22/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContent"
                  }
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v23/*: any*/),
                        (v24/*: any*/),
                        (v25/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContext"
                  }
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v27/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContextAncestors"
                  }
                ]
              },
              (v18/*: any*/),
              (v26/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v39/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v48/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v49/*: any*/)
                ]
              },
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v53/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ByLineContributors_contentContributors"
              }
            ]
          }
        ]
      },
      {
        "args": (v54/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentContainerTheme_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          (v18/*: any*/),
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v55/*: any*/),
              (v20/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v66/*: any*/),
                  (v69/*: any*/)
                ]
              }
            ]
          },
          (v70/*: any*/),
          (v71/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v9/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v29/*: any*/),
              (v26/*: any*/),
              (v43/*: any*/),
              (v18/*: any*/),
              (v28/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v39/*: any*/),
              (v42/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "emojiTitlePublished",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "emoji-title-published"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": (v41/*: any*/),
                    "storageKey": "properties(key:\"emoji-title-published\")"
                  },
                  {
                    "alias": "editorProperty",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v40/*: any*/),
                          (v35/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                  },
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "homepageId"
                      }
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v73/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v73/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": (v73/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": (v73/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                      },
                      (v31/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "contentTypeModified"
                      }
                    ]
                  },
                  (v49/*: any*/),
                  (v50/*: any*/)
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v16/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v72/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v22/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v27/*: any*/)
                ]
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v47/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v72/*: any*/),
                          (v48/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v49/*: any*/)
                ]
              },
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v54/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v55/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v66/*: any*/),
                  (v69/*: any*/),
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v56/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/),
                      (v63/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v62/*: any*/),
                      (v59/*: any*/),
                      (v61/*: any*/),
                      (v60/*: any*/),
                      (v68/*: any*/),
                      (v67/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": [
                  (v40/*: any*/),
                  (v35/*: any*/)
                ]
              }
            ]
          },
          (v18/*: any*/),
          (v70/*: any*/),
          (v71/*: any*/)
        ]
      },
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v53/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isCurrentUserContributor"
              },
              {
                "kind": "ScalarField",
                "name": "isOwnerContributor"
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v73/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d0ebf4a4ad44eb19a0a1f0a93250c888",
    "id": "4f36b0eef5d8fa7c63c71625e945d131f6839456bf7a2512aa5cd06fbe2a3e87",
    "metadata": {},
    "name": "ContentUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$bylineContributorsLimit:Int,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false)@allowHigherTimeout{content(id:$contentId,version:$versionOverride){nodes{...PageStatusQueryRelaySpike_content,...PresenterModePortal_content,...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n      labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n      contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}},id@include(if:$includeRestrictions)\n      hasInheritedRestrictions@include(if:$includeRestrictions)\n      hasViewRestrictions@include(if:$includeRestrictions)\n      hasRestrictions@include(if:$includeRestrictions),id@include(if:$includeRestrictionAncestors)\n      ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},id,title,type,status,version{confRev,number,when@include(if:$includeAgentTrustReceiptData)},metadata{lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},operations{operation,targetType},subType,space{id,key,alias},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}}},contentContributors(id:$contentId,limit:$bylineContributorsLimit)@include(if:$includeBylineContributors){...ByLineContributors_contentContributors},space(key:$spaceKey){...ContentContainerTheme_space,...ContentTitle_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ByLineContributors_contentContributors on ContentContributors{count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment PageStatusQueryRelaySpike_content on Content{status}fragment PresenterModePortal_content on Content{title,properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}"
  }
};
})();

(node as any).hash = "49fcb342dd3436b37cf2072447054027";

export default node;
